export default __webpack_public_path__ + "static/media/characterback.af53b44d.png";